/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Hoogenverspringen4Inputs */

const nl_enums_beweegthema_hoogenverspringen4 = /** @type {(inputs: Enums_Beweegthema_Hoogenverspringen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoog- en verspringen`)
};

/**

* @param {Enums_Beweegthema_Hoogenverspringen4Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_hoogenverspringen4 = /** @type {((inputs?: Enums_Beweegthema_Hoogenverspringen4Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Hoogenverspringen4Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_hoogenverspringen4(inputs)
});
export { enums_beweegthema_hoogenverspringen4 as "enums.Beweegthema.HoogEnVerspringen" }